export const breakpoints = ["38em", "72em", "80em"];
